export const environment = {
    production: false,
    apiUrl: "https://hnah3s4prs4gwo4ilwqcmiwguy0gzabb.lambda-url.sa-east-1.on.aws",
    siteKey: "6LcslDwqAAAAAMnaDio3qymmze7vLQjmZSShxhXu"
    //apiUrl: 'https://sumep-dev-gwbgd2c0e5fkgscd.brazilsouth-01.azurewebsites.net'
  };